import React from 'react';
import { callTagAdapter } from '../Utils';
import styled from "styled-components";

const ModalHeader = styled.div`
  .mdn-Modal-header {
    padding-bottom: 0 !important;
    padding-right: 25px;

    .mdn-Heading {
      padding-bottom: 0 !important;
    }
  }
`;

const MondrianModalHeader = ({ closeModal, title, disableCloseButton, props }) => (
  <ModalHeader>
    <div className="mdn-Modal-header">
      {title && <div className='mdn-Heading mdn-Heading--sm'>{title}</div>}
      {!disableCloseButton && (
        <button
          className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary"
          onClick={() => {
            closeModal(props);
            callTagAdapter({ nome_item: "fechar", nome_modal: title });
          }}
          aria-label="Fechar modal"
        >
          <i className="mdn-Icon-fechar mdn-Icon--sm">
            <title>Fechar Modal</title>
          </i>
        </button>
      )}
    </div>
  </ModalHeader>
);

export default MondrianModalHeader;
